import { useSelector } from 'react-redux';

import { makeGetProject, makeGetActiveProjects } from 'selectors/projects';
import { makeGetResolvedProjectUsers } from 'selectors/users';

import { usePlanTotalProjects } from 'shared-hooks/billing';
import { useCurrentUserRole } from 'shared-hooks/user';

const getProject = makeGetProject();
const getActiveProjects = makeGetActiveProjects();
const getResolvedProjectUsers = makeGetResolvedProjectUsers();

export const useProject = projectId => {
    const project = useSelector(({ projects }) => projectId ? getProject(projects.items, projectId) : null);

    return project;
};

export const useProjectModuleDisabled = (projectId, moduleName) => {
    const project = useProject(projectId);

    return (project?.disabled_modules || []).includes(moduleName);
};

export const useProjectHasAutoMilestones = projectId => {
    const project = useProject(projectId);

    return Boolean(project?.auto_milestones);
}

export const useProjectQueryAllFiles = projectId => {
    const project = useProject(projectId);

    // return Boolean(project?.query_all_files);
    return true;
}

export const useRemainingProjects = () => {
    const totalPlanProjects = usePlanTotalProjects();
    const activeProjects = useSelector(({ projects }) => getActiveProjects(projects.items));

    return totalPlanProjects - activeProjects.length;
}

export const useCanCreateProject = () => {
    const reminingProjects = useRemainingProjects();
    return reminingProjects > 0;
}

export const useResolvedProjectUsers = projectId => {
    const project = useProject(projectId);
    const projectUsers = useSelector(({ users }) => project ? getResolvedProjectUsers(project, users) : []);

    return projectUsers;
}

export const useCanViewOtherUsers = projectId => {
    const project = useProject(projectId);
    const currentUserRole = useCurrentUserRole();

    if (currentUserRole !== 'client') {
        return true;
    }

    if (!project) {
        return true;
    }

    if (!project.hide_users_from_guests) {
        return true;
    }

    return false;
}
